<template>
    <d2-container>
        <h2>街镇列表</h2>
        <el-form ref="elForm" :model="formData" size="medium" label-width="100px">
            <el-row gutter="15">
                <el-form-item label="街镇名称" prop="dd">
                    <el-input v-model="listQuery.streetName" placeholder="街镇名称" clearable :style="{width: '763px'}"></el-input>
                </el-form-item>
            </el-row>
            <el-form-item size="large">
                <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">查询</el-button>
                <el-button @click="resetForm">重置</el-button>
            </el-form-item>
        </el-form>


        <!--表格-->
        <el-button size="small" class="filter-item"  style="margin-left: 10px;" @click="handleCreate" type="primary" icon="edit">新增街镇</el-button>
        <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row style="width: 100%">
            <el-table-column
                    type="selection"
                    width="55" label="序号">
            </el-table-column>
            <el-table-column
                    fixed
                    label="类型" >
                <template slot-scope="scope">
                    <span>{{townType(scope.row.type)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    fixed
                    prop="cityName"
                    label="城市" >
                <template slot-scope="scope">
                    <span>{{scope.row.cityName}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="countyName"
                    label="区县" >
                <template slot-scope="scope">
                    <span>{{scope.row.countyName}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="streetName"
                    label="街镇" >
            </el-table-column>
            <el-table-column
                    prop="sort"
                    label="排序" >
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作" width="240">
                <template slot-scope="scope">
                    <el-button size="small" @click="handleClick(scope.row)">查看</el-button>
                    <el-button size="small" type="success" @click="handleUpdate(scope.row)">编辑</el-button>
                    <el-button size="small" type="danger" @click="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <template slot="footer">
            <div v-show="!listLoading" class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit" layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
            </div>
        </template>


        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :model="form" :rules="rules" ref="form" label-width="100px">
                <el-form-item label="类型">
                    <el-select v-model="form.type" placeholder="请选择类型" @change="typeChange" clearable :style="{width: '100%'}">
                        <el-option v-for="(item, index) in townTypes" :key="index" :label="item.label" :value="item.value"
                                   :disabled="item.disabled"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择上级">
                    <el-cascader
                            :options="townTree" @change="parentChange"></el-cascader>
                </el-form-item>
                <el-form-item label="城市" v-if="form.type=='city'">
                    <el-input v-model="form.cityName" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="区县" v-if="form.type=='county'">
                    <el-input v-model="form.countyName" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="街镇" v-if="form.type=='street'">
                    <el-input v-model="form.streetName" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="form.sort" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel('form')"  size="small">取 消</el-button>
                <el-button v-if="dialogStatus=='create'"  size="small" type="primary" @click="create('form')">确 定</el-button>
                <el-button v-if="dialogStatus=='update'" type="primary" size="small" @click="update('form')">确 定</el-button>
            </div>
        </el-dialog>

    </d2-container>
</template>


<script>
    import {
        page,
        addObj,
        getObj,
        delObj,
        putObj,
        getTree
    } from '@/api/admin/sysBaseTown/index';
    import { mapGetters } from 'vuex';
    export default {
        name: 'sysBaseMaterial',
        data() {
            return {
                dialogFormVisible:true,
                formData: {
                    cityName: undefined,
                    bb: undefined,
                    cc: undefined,
                    dd: undefined,
                },
                list: null,
                total: null,
                listLoading: true,
                listQuery: {
                    page: 1,
                    limit: 20,
                    streetName:null,
                },
                dialogFormVisible: false,
                dialogStatus: '',
                textMap: {
                    view: '查看',
                    update: '编辑',
                    create: '创建'
                },
                tableKey: 0,
                form:{
                    townId:null,
                    parentId:-1,
                    cityName:null,
                    countyName:null,
                    streetName:null,
                    sort: null,
                    type: null,
                },
                townTypes:[
                    {label:"省市", value:"city"},
                    {label:"区县", value:"county"},
                    {label:"街镇", value:"street"},
                ],
                townTree:[]
            }
        },
        created() {
            this.getList();
        },
        computed: {
            ...mapGetters([
                'elements'
            ])
        },
        methods: {
            townType(type){
                if(type=='city'){
                    return '省市';
                }else if(type=='county'){
                    return '区县';
                }else if(type=='street'){
                    return '街镇';
                }
                return '类型错误';
            },
            typeChange(type){
                this.getTownList(type);
            },
            parentChange(selectIds){
                this.form.parentId = selectIds[selectIds.length-1];
            },
            getList() {
                this.listLoading = true;
                page(this.listQuery).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.listLoading = false;
                })
            },
            getTownList(noType){
                getTree({parentId: -1,noType: noType}).then(response=>{
                    this.townTree = response;
                });
            },
            handleFilter() {
                this.getList();
            },
            handleSizeChange(val) {
                this.listQuery.limit = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.listQuery.page = val;
                this.getList();
            },
            handleCreate() {
                this.resetTemp();
                this.dialogStatus = 'create';
                this.dialogFormVisible = true;
            },
            handleClick(row) {
                getObj(row.townId)
                    .then(response => {
                        this.form = response;
                        this.dialogFormVisible = true;
                        this.dialogStatus = 'view';
                    });
            },
            handleUpdate(row) {
                getObj(row.townId)
                    .then(response => {
                        this.form = response;
                        this.dialogFormVisible = true;
                        this.dialogStatus = 'update';
                    });
            },
            handleDelete(row) {
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        delObj(row.townId)
                            .then(() => {
                                this.$notify({
                                    title: '成功',
                                    message: '删除成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                const index = this.list.indexOf(row);
                                this.list.splice(index, 1);
                            });
                    });
            },
            create(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        addObj(this.form)
                            .then(() => {
                                this.dialogFormVisible = false;
                                this.getList();
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                });
                            })
                    } else {
                        return false;
                    }
                });
            },
            cancel(formName) {
                this.dialogFormVisible = false;
                const set = this.$refs;
                set[formName].resetFields();
            },
            update(formName) {
                const set = this.$refs;
                set[formName].validate(valid => {
                    if (valid) {
                        this.dialogFormVisible = false;
                        this.form.password = undefined;
                        putObj(this.form.id, this.form).then(() => {
                            this.dialogFormVisible = false;
                            this.getList();
                            this.$notify({
                                title: '成功',
                                message: '创建成功',
                                type: 'success',
                                duration: 2000
                            });
                        });
                    } else {
                        return false;
                    }
                });
            },
            resetTemp() {
                this.form = {
                    townId:null,
                    cityName:null,
                    countyName:null,
                    streetName:null,
                    sort:null,
                };
            },
            resetForm(){
                this.listQuery={
                    page: 1,
                    limit: 20,
                    materialName: null,
                }
            }
        }
    }
</script>

